"use client";

const differentiators = [
  {
    icon: "01",
    title: "We\u2019ve Actually Done the Job",
    description:
      "JAMO doesn\u2019t advise from the sidelines. We\u2019ve held the executive titles, managed the teams, and owned the outcomes. When we recommend a path, it\u2019s because we\u2019ve walked it\u2014at companies operating at real scale.",
    context: "Operators, Not Advisors",
  },
  {
    icon: "02",
    title: "From IC to Executive and Back",
    description:
      "Most consultancies live at one level. JAMO moves between executive leadership, middle management, and hands-on engineering based on where the impact is greatest. Cloud architecture on Monday, board presentation on Friday.",
    context: "Full-Stack Leadership",
  },
  {
    icon: "03",
    title: "We Build Things That Last",
    description:
      "The teams, processes, and infrastructure JAMO builds outlast the engagement. From incident management programs to entire engineering departments, we design for sustainability\u2014not dependency.",
    context: "Lasting Impact",
  },
];

export default function TestimonialsSection() {
  return (
    <section aria-label="Why work with us" className="py-20 sm:py-24 md:py-32 bg-[#111114] relative overflow-hidden">
      {/* Decorative gold corner */}
      <div aria-hidden="true" className="absolute top-0 right-0 w-64 h-64 opacity-[0.03]"
      style={{
        background: "radial-gradient(circle at top right, #B8986A, transparent 70%)"
      }} />

      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="flex items-center gap-3 sm:gap-4 mb-12 sm:mb-16 md:mb-20 reveal-hidden" data-reveal>
          <div className="w-6 sm:w-8 h-[1px] bg-[#B8986A]" />
          <span className="text-[9px] sm:text-[10px] font-bold tracking-[0.3em] sm:tracking-[0.35em] uppercase text-[#B8986A]">
            Why Work With Us
          </span>
        </div>

        <h2
          className="font-fraunces text-[clamp(2rem,8vw,4.5rem)] sm:text-[clamp(2.5rem,5vw,4.5rem)] font-light leading-[1.05] tracking-tight text-[#F2EFE9] mb-12 sm:mb-16 md:mb-20 reveal-hidden"
          data-reveal>

          The JAMO
          <br />
          <span className="italic text-gradient-gold">Difference.</span>
        </h2>

        {/* Differentiator Cards */}
        <div className="grid md:grid-cols-3 gap-px bg-[rgba(242,239,233,0.06)]">
          {differentiators.map((d, i) => (
            <div
              key={d.title}
              className={`bg-[#111114] p-6 sm:p-8 md:p-10 reveal-hidden delay-${i * 100 + 100}`}
              data-reveal>

              {/* Context Badge */}
              <div className="inline-block px-3 py-1 border border-[rgba(184,152,106,0.2)] rounded-sm mb-6">
                <span className="text-[9px] font-bold tracking-[0.2em] uppercase text-[#B8986A]">
                  {d.context}
                </span>
              </div>

              {/* Title */}
              <h3 className="font-fraunces text-xl sm:text-2xl font-light text-[#F2EFE9] mb-4 tracking-tight">
                {d.title}
              </h3>

              {/* Description */}
              <p className="text-[#A09D97] text-sm font-light leading-relaxed">
                {d.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>);

}
